// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3vOiZ","subheader":"ReorderModal_subheader__CXWQS","listWrap":"ReorderModal_listWrap__cD7Ah"};